import { render, staticRenderFns } from "./ViewClientePolizaInfo.vue?vue&type=template&id=4bd3e5fc&scoped=true&"
import script from "./ViewClientePolizaInfo.vue?vue&type=script&lang=js&"
export * from "./ViewClientePolizaInfo.vue?vue&type=script&lang=js&"
import style0 from "./ViewClientePolizaInfo.vue?vue&type=style&index=0&id=4bd3e5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3e5fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
